import type { FilterState } from '@/types/filter/filterState';
import type { OptionPathsByFilter } from '@/context/FiltersContext/FiltersContext';
import { isSharedViewFilterState, isSharedViewPayload } from '@/hooks/useApplySharedView.utils';

export interface ParsedSharedView {
  kind: 'structured' | 'flat';
  globalFilters: FilterState;
  localFilters: Record<string, Record<string, unknown>> | undefined;
  resolvedCountryCodes: string[] | undefined;
  senderCountryCodes: string[] | undefined;
  optionPaths: OptionPathsByFilter | undefined;
}

export const parseSharedViewPayload = (migratedPayload: unknown): ParsedSharedView | null => {
  if (isSharedViewPayload(migratedPayload)) {
    return {
      kind: 'structured',
      globalFilters: migratedPayload.globalFilters,
      localFilters: migratedPayload.localFilters,
      resolvedCountryCodes: migratedPayload.resolvedCountryCodes,
      senderCountryCodes: migratedPayload.senderCountryCodes,
      optionPaths: migratedPayload.optionPaths,
    };
  }

  if (isSharedViewFilterState(migratedPayload) && Object.keys(migratedPayload).length > 0) {
    return {
      kind: 'flat',
      globalFilters: migratedPayload,
      localFilters: undefined,
      resolvedCountryCodes: undefined,
      senderCountryCodes: undefined,
      optionPaths: undefined,
    };
  }

  return null;
};
